module.exports = __webpack_public_path__ + "static/sour-cream-onion-4-8eeb7f76fad20555ef81deb99652e8c8.png";